// WS #2219705 (QA 10-19, item 1). A PACK client may have no email, so the copy of the signed agreement that
// is emailed after signing reaches nobody. The signing page keeps the PDF it has just signed (the same bytes
// the server stores and emails) in memory only, and the success page offers it as a download. Nothing is
// sent or stored elsewhere, so a reload, another tab or a later visit has no copy. The agreement shows full
// card numbers, which is why there is no link to it.
let signedCopy = null

export const keepSignedCopy = (dataUrl) => {
  signedCopy = typeof dataUrl === 'string' && dataUrl.startsWith('data:application/pdf') ? dataUrl : null
}

export const signedCopyKept = () => signedCopy

export const forgetSignedCopy = () => {
  signedCopy = null
}

export const downloadSignedCopy = (dataUrl, fileName) => {
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1)
  const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0))
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
